import getParameterFromURL from './getParameterFromURL';
import saveRandomValue from './saveRandomValue';

type StepConfigItem = { name: string; [key: string]: unknown };

const AB_TEST_KEY = 'p20v1_onboarding_name';

// Ссылка v1p20: config=customV2 (pageUrlValue v1) + tariff=v41 + everydoggyV5/V10
// (paymentVersion p20). Тест включается Firebase-флагом p20v1_onboarding_name.
function isP20V1(): boolean {
  const config = getParameterFromURL('config');
  const tariff = getParameterFromURL('tariff') || null;
  const everydoggyV5 = getParameterFromURL('everydoggyV5') === 'true';
  const everydoggyV10 = getParameterFromURL('everydoggyV10') === 'true';
  const firebase = window.firebaseConfigData;

  return config === 'customV2'
    && tariff === 'v41'
    && (everydoggyV5 || everydoggyV10)
    && !!firebase
    && firebase[AB_TEST_KEY] === 'true';
}

// Распределение 50/50. Вызывается на шаге customV2_gender.
// saveRandomValue шлёт AB_TEST-событие (ab_test_type: onboarding) на каждый вызов.
export function assignOnboardingNameAbTest(): void {
  if (!isP20V1()) return;
  saveRandomValue(2, AB_TEST_KEY, 'A', 'B', 50, 50);
}

// Вариант B активен — шаг customV2_name переносится в конец опроса,
// сразу после statement_strong_bond.
export function isOnboardingNameVariantB(): boolean {
  if (!isP20V1()) return false;
  return localStorage.getItem(AB_TEST_KEY) === 'B';
}

// Возвращает копию конфига, где customV2_name стоит после statement_strong_bond.
// Если одного из шагов нет или имя уже стоит после якоря — конфиг не меняется.
export function moveNameStepForVariantB(config: StepConfigItem[]): StepConfigItem[] {
  const nameIndex = config.findIndex((step) => step.name === 'customV2_name');
  const anchorIndex = config.findIndex((step) => step.name === 'statement_strong_bond');
  if (nameIndex === -1 || anchorIndex === -1 || nameIndex > anchorIndex) return config;

  const result = [...config];
  const [nameStep] = result.splice(nameIndex, 1);
  result.splice(result.findIndex((step) => step.name === 'statement_strong_bond') + 1, 0, nameStep);
  return result;
}
